.sync_status
  display: inline-flex
  flex-direction: column
  position: relative
  font-size: initial
  font-weight: initial
  line-height: initial
  vertical-align: middle

  // Create a larger hover area
  &:before
    position: absolute
    display: block
    content: ' '
    top: -15px
    bottom: -15px
    left: -15px
    right: -15px
  
  // Add an element to hold the amount of space the longest status text occupies
  &:after
    display: block
    content: var(--spaceholder)
    height: 0
    overflow: hidden

  .content
    display: flex

  .text
    padding-left: 0.5ch
    overflow: hidden
    white-space: nowrap
    transition: flex 0.7s ease-in-out
    flex: 0 0 0

  &.status-changed, &.always-show-status, &:hover
    .text
      transition-duration: 0.3s
      flex: 1 1 0
    

  @media (prefers-reduced-motion)
    .text
      transition-duration: 0s

.sync_status.display-block
  display: grid
  margin: 0 0.5ch

.sync_status.right
  float: right
  align-items: end

  .content
    justify-content: end

  & + *
    clear: right
